module.exports = __webpack_public_path__ + "static/media/center.57e77a1d.svg";